// Large PDFs in Add pages / Replace pages (26 Oct 2026; plan ~/Code/CUELIST_LARGE_PDF_PAGES_PLAN_2026-10-26.md).
// The helper runs on Cloud Run, which refuses request bodies over 32 MiB, so the new PDF goes to Storage
// first (page-uploads/{project id}/) and the request carries only its path. The helper deletes it after.
//
/* global crypto */
// Pure module (no imports) so it can be unit tested under node; page-upload-client.js passes in firebase.

// Josh, 26 Oct: refuse PDFs over 250 MB, before anything uploads. Decimal MB, as Finder shows sizes.
export const MAX_PAGE_PDF_BYTES = 250 * 1000 * 1000;

export const PAGE_UPLOAD_FAILED_MESSAGE = "The PDF couldn't be uploaded. Check your connection and try again.";

// The approved message for a file over the cap, or null when it fits.
export function pdfTooLargeMessage(bytes) {
    if (!(bytes > MAX_PAGE_PDF_BYTES)) return null;
    const mb = Math.ceil(bytes / (1000 * 1000));
    return `This PDF is ${mb} MB. Cuelist can add PDFs up to 250 MB. Compress it and try again.`;
}

export function newPageUploadPath(projectId) {
    const bytes = new Uint8Array(12);
    crypto.getRandomValues(bytes);
    const id = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `page-uploads/${projectId}/${id}.pdf`;
}

// Marks an error as "the PDF never reached the helper": nothing was changed, so the caller says so.
export function pageUploadFailed(error) {
    const e = error instanceof Error ? error : new Error(String(error));
    e.pageUploadFailed = true;
    return e;
}

// refFor(path) -> a Storage ref with put(file). Resolves to the uploaded path.
export function makeUploadPageFile(refFor) {
    return async function uploadPageFile(projectId, file) {
        const path = newPageUploadPath(projectId);
        try {
            await refFor(path).put(file, { contentType: 'application/pdf' });
        } catch (e) {
            throw pageUploadFailed(e);
        }
        return path;
    };
}


// WEBPACK FOOTER //
// ./src/lib/page-upload.js